/**
 * Generates a version 4 UUID (Universally Unique Identifier).
 * This function takes no parameters.
 * @returns {string} A new UUID v4 string.
 */
export function uuidV4(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    // | 0 is a fast way to get an integer from a float
    const r = (Math.random() * 16) | 0;

    // Use strict equality for type and value comparison
    const v = c === 'x' ? r : (r & 0x3) | 0x8;

    return v.toString(16);
  });
}
